<template>
  <div class="py-8 md:p-[50px] lg:p-[100px]">
    <div class="">
      <div
        class="flex flex-col gap-[10px] md:gap-[20px] text-start px-4 md:px-0"
      >
        <h1 class="text-[24px] md:text-[32px] lg:text-[36px] font-semibold">
          {{ getLocalized(contentData, "title") }}
        </h1>
        <p class="text-[16px] lg:text-[24px] max-w-[800px]">
          {{ getLocalized(contentData, "description") }}
        </p>
      </div>
      <div class="mt-[10px] md:mt-[40px]">
        <benefit-component></benefit-component>
      </div>
    </div>
  </div>
</template>

<script>
import benefitComponent from "./benefitComponent.vue";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";
export default {
  components: { benefitComponent },
  data() {
    return {
      contentData: {},
      api: process.env.VUE_APP_API_KEY,
      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  methods: {
    async fetchContent() {
      try {
        this.contentData = await fetchContentSection(1);
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.fetchContent();
  },

  computed: {
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
};
</script>
